var _excluded = ["iconOnly", "iconOptions", "copyOptions", "errorCopy", "refreshCopy", "refetch"];
var _jsxFileName = "/runner/_work/smpackages/smpackages/packages/webassets/src/components/ErrorCard/index.js",
  _this = this;
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import { IconWarning } from '@wds/icons';
import { Section } from '@wds/section';
import { Box } from '@wds/box';
import { Button } from '@wds/button';
import { Typography } from '@wds/typography';
import { T } from '@sm/intl';
import COPY from './Copy';
import useStyles from './useStyles';
import { WebAssetsThemeWrapper } from '../../theme';
var ErrorCard = function ErrorCard(props) {
  return /*#__PURE__*/React.createElement(WebAssetsThemeWrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15,
      columnNumber: 3
    }
  }, /*#__PURE__*/React.createElement(ErrorCardContent, Object.assign({}, props, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 16,
      columnNumber: 5
    }
  })));
};
var ErrorCardContent = function ErrorCardContent(_ref) {
  var iconOnly = _ref.iconOnly,
    iconOptions = _ref.iconOptions,
    copyOptions = _ref.copyOptions,
    errorCopy = _ref.errorCopy,
    refreshCopy = _ref.refreshCopy,
    refetch = _ref.refetch,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var classes = useStyles();
  var Icon = /*#__PURE__*/React.createElement(IconWarning, Object.assign({
    title: "An error has occurred"
  }, iconOptions, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 30,
      columnNumber: 16
    }
  }));
  var getErrorMessage = function getErrorMessage() {
    if (!errorCopy) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, refetch ? /*#__PURE__*/React.createElement(T, {
        desc: COPY.troubleLoading,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 36,
          columnNumber: 13
        }
      }) : /*#__PURE__*/React.createElement(T, {
        desc: COPY.weSlippedError,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 38,
          columnNumber: 13
        }
      }));
    }
    return errorCopy;
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, iconOnly ? /*#__PURE__*/React.createElement(Box, Object.assign({
    display: "flex",
    flexJustify: "center",
    flexAlign: "center"
  }, otherProps, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 49,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(Typography, {
    "data-testid": "ErrorCard",
    component: "h2",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 55,
      columnNumber: 11
    }
  }, Icon)) : /*#__PURE__*/React.createElement(Section, {
    "data-testid": "ErrorCard",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 60,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Box, Object.assign({
    display: "flex",
    flexJustify: "center"
  }, otherProps, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 61,
      columnNumber: 11
    }
  }), /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexAlign: "center",
    mr: 3,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 62,
      columnNumber: 13
    }
  }, Icon), /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexAlign: "center",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 65,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(Typography, Object.assign({}, copyOptions, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 66,
      columnNumber: 15
    }
  }), getErrorMessage())), refetch ? /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexAlign: "center",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 69,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(Button, {
    px: 1,
    variant: "text",
    size: "sm",
    onClick: function onClick() {
      return refetch();
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 70,
      columnNumber: 17
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.refreshText,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 76,
      columnNumber: 19
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "link",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 77,
      columnNumber: 21
    }
  }, refreshCopy ? /*#__PURE__*/React.createElement(React.Fragment, null, refreshCopy) : /*#__PURE__*/React.createElement(T, {
    desc: COPY.refresh,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 81,
      columnNumber: 25
    }
  }))))) : null)));
};
ErrorCardContent.propTypes = {
  /**
   * Show only the Error Icon without any text.
   */
  iconOnly: PropTypes.bool,
  /**
   * This is a prop overrides object for the IconWarning component.
   */
  iconOptions: PropTypes.shape({
    color: PropTypes.string,
    size: PropTypes.oneOf(['lg', 'md', 'sm', 'xl'])
  }),
  /**
   * Refetch function; Shows a button to refetch data.
   */
  refetch: PropTypes.func,
  /**
   * This is a prop overrides object for the Typography component.
   */
  copyOptions: PropTypes.shape({
    variant: PropTypes.string
  }),
  /**
   * Error Message.
   */
  errorCopy: PropTypes.string,
  /**
   * Refetch Button Message.
   */
  refreshCopy: PropTypes.string
};
ErrorCardContent.defaultProps = {
  iconOnly: false,
  iconOptions: {
    color: null,
    size: 'lg'
  },
  refetch: undefined,
  copyOptions: {
    variant: 'sectionTitle'
  },
  errorCopy: undefined,
  refreshCopy: undefined
};
export default ErrorCard;
//# sourceMappingURL=index.js.map